/**
 * Logo.jsx — QuotesFlow logo component.
 *
 * Uses the production hardhat-in-orange-square mark sitting at
 * /branding/qf-logo.jpg. The actual image is bitmap (JPG) so we render it
 * inside a rounded container that masks the JPG's white edges; this matches
 * the source artwork without producing visible white seams against off-white
 * page backgrounds.
 *
 * Props:
 *   - size: 'sm' | 'md' | 'lg' (controls both icon size and wordmark size)
 *   - showWord: when false, only the icon is rendered (useful for tight UIs
 *     like the support chat avatar, favicon, footer mark, etc.)
 *   - className: forwarded to the root flex container
 */
import React from 'react';

const SIZE_MAP = {
    sm: { box: 'h-6 w-6', text: 'text-sm' },
    md: { box: 'h-8 w-8', text: 'text-lg' },
    lg: { box: 'h-10 w-10', text: 'text-2xl' },
};

export function Logo({ size = 'md', showWord = true, className = '' }) {
    const s = SIZE_MAP[size] || SIZE_MAP.md;
    return (
        <div className={`flex items-center gap-2 ${className}`} data-testid="qf-logo">
            <div className={`relative ${s.box} rounded-lg overflow-hidden shadow-sm ring-1 ring-amber-500/20 bg-amber-500 flex items-center justify-center`}>
                <img
                    src="/branding/qf-logo.jpg"
                    alt="QuotesFlow"
                    className="h-full w-full object-cover"
                    draggable={false}
                />
            </div>
            {showWord && (
                <span className={`font-display font-bold tracking-tight text-slate-900 ${s.text}`}>
                    QuotesFlow<span className="text-amber-500">.</span>
                </span>
            )}
        </div>
    );
}
